module.exports = __webpack_public_path__ + "img/wide.e818cc03.jpg";